import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,RecordHeader,TabSet,Tab,Button,Display,Card} from 'ktm-ui';
import EditScreen from './Edit';


interface IdsDivision {
    Id:string;
    Policy_Id:string;
    Name:string;
    Description:string;
    IsActive:boolean;
};

export default KTMScreen({name:"enroll.division.record"}, class extends React.Component<{division_id:string}> {

    data:{
        dsDivision:IdsDivision;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsDivision";
        await KTMApi.start(screen,{
            "@division_id":this.props.division_id,
        });
        screen.title = this.data.dsDivision.Name;
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.tabs)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <RecordHeader entityLabel="Division" label={this.data.dsDivision.Name}>
            </RecordHeader>
        );
    }

    tabs({field,draw,action}:RenderEvent){
        return (
            <TabSet>
                <Tab label="Details" template={this.details}/>
            </TabSet>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card label="Details" actions={<><Button action={action(this.edit)} label="Edit" style="link"/></>}>
                <Display field={field("Name")}/>
                <Display field={field("Description")}/>
            </Card>
        );
    }

    async edit({screen}:ActionEvent){
        await screen.openDialog(<EditScreen division_id={this.data.dsDivision.Id}/>
,{onRecordChanged:this.refresh_data});
    }

    async refresh_data({screen}:ActionEvent){
        await screen.restart();
    }

});
